export const CampaignFormStages = [
  {
    title: "Campaign",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "name",
            description: "",
            isNameField: true,
            label: "Name",
            required: true,
            type: "nvarchar",
          },
        ],
      },
    ],
  },
];
